module.exports = __webpack_public_path__ + "img/slide-13.feffdd4e.jpeg";